import React from 'react';
import ReactDOM from 'react-dom';
import App from './Components/App';
import "./style/app.css"



ReactDOM.render(<App />, document.getElementById('root'))